import React, { Component } from 'react'
import PropTypes from 'prop-types'

import serialize from 'form-serialize'
import some from 'lodash/some'
import get from 'lodash/get'
import flatten from 'lodash/flatten'

export default class Form extends Component {

  static propTypes = {
    onData: PropTypes.func.isRequired,
    postProcessData: PropTypes.func,    // if provided, asynchronously augment the data object after it's been serialized and validated
    includeEmpty: PropTypes.bool,    // if true, include empty fields (including false checkboxes) when serializing
    validations: PropTypes.array,
    errorsAbove: PropTypes.bool         // if true, position error messages above form instead of below
  }

  static defaultProps = {
    validations: [],
    errorsAbove: false,
    includeEmpty: false,
    postProcessData: null
  }

  state = {
    saving: false,
    saved: false,
    problems: []
  }

  /*
   * Begin processing the submit. If postProcessData is provided,
   * it's an async function that augments the payload. If not,
   * proceed with finishSubmit() synchronously.
   */
  submitHandler = (event) => {
    const form = event.target
    const { postProcessData, includeEmpty } = this.props

    event.preventDefault()

    let opts = { hash: true }
    if (includeEmpty) opts.empty = true

    let data = serialize(form, opts)
    if (postProcessData) 
      postProcessData(data).then(this.finishSubmit)
    else
      this.finishSubmit(data)
  }

  /*
   * Finish up a submit started by submitHandler()
   */
  finishSubmit = (data) => {
    const { onData, } = this.props

    const problems = this.validate(data)

    this.setState({ saved: false, problems }, () => {
      if (!this.state.problems.length) {
        this.setState({ saving: true })
        onData(data).then(
          // FIXME it's possible the component has unmounted before this promise resolves
          // e.g. The create a search form goes back to the `return_to` if set.
          () =>    this.setState({ saving: false, saved: true }),
          error => {
            let problems
            const errors = error.response && error.response.data && error.response.data.errors
            if (errors) {
              const fields = Object.keys(errors)
              problems = flatten(fields.map(field => errors[field].map(msg => `${field} ${msg}`)))
            } else {
              problems = [`${error}`]
            }
            this.setState({ saving: false, problems })
          }
        )
      }
    })
  }

  validate(data) {
    const { validations } = this.props
    const problems = []

    if (!validations) return problems

    validations.forEach(({ field, validate, message }) => {
      const validators = Array.isArray(validate) ? validate : [validate]
      const invalid = some(validators, validator => validator(get(data, field), data))
      if (invalid) problems.push(message)
    })

    return problems
  }

  getProblems() {
    const { problems } = this.state
    if (problems.length) {
      return (
        <ul className="error">
          <h3>There was a problem saving these settings:</h3>
          {problems.map((msg,i) => <li key={`${msg}-${i}`}>{msg}</li> )}
        </ul>
      )
    }
  }

  /*
   * Note that postProcessData and includeEmpty are extracted from this.props below just to
   * exclude it from the local props, so we can pass it to the <form> element.
   */
  render() {
    const { validations, onData, errorsAbove, postProcessData, includeEmpty, ...props }= this.props
    const { saving, saved } = this.state

    return (
      <form ref={el => this.form = el} {...props} onSubmit={this.submitHandler}>
        {!errorsAbove && this.props.children}
        {this.getProblems()}
        {saving && <div className="panel padded saving">Saving...</div>}
        {saved && <div className="panel padded saved">Saved!</div>}
        {errorsAbove && this.props.children}
      </form>
    )
  }

}



// WEBPACK FOOTER //
// client/components/util/Form/index.js